import wrapElements from './wrap-elements';

export default function wrap(elements, rect) {
    return wrapElements(elements, rect, "x", "y", "width");
}